export default "__VITE_ASSET__D0pI4HdE__"